<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Personnel Assigned to Role '{{inner_Role.title}}'</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button (click)="openModal_Person(templatePerson)" type="button" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Add Personnel </button>
          <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_RoleUser
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_RoleUser|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_RoleUser.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a  style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4  class="modal-title pull-left">Remove Personnel
      '{{Data_Seleted_Delete.fullname}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button  type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Delete <i class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templatePerson>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Personnel List </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">Last Name</label>
          <input [(ngModel)]="Filter_Familly" (keyup)="Change_Filter()" name="Filter_Familly" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Last Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Person
            |filter:Filter_Familly:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: Personpage,
                        totalItems: (DataList_Person
                        |filter:Filter_Familly:'fullname'
                        ).length
                      }
            ">
              <td>{{DataList_Person.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td (click)="Set_Selected_Person_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="Procssing_Person" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!Procssing_Person" type="button" (click)="ReadData_Person()"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">Close</button>
  </div>
</ng-template>